<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="10"
                :options.sync="options"
                :loading="isLoading"
                :server-items-length="totalItems"
                item-key="id"
                class="elevation-1 border-transparent"
                :loading-text="$t('loadingPleaseWait')"
                :no-data-text="$t('noData')"
                :footer-props="footerProps"
                :header-props="headerProps"
        >
            <template v-slot:item.existence="{ item }">
                <control-existence :control-data="item" @update="updateItem"></control-existence>
            </template>
            <template v-slot:item.pack="{ item }">
                <pack v-if="item.pack" :pack="item.pack"></pack>
            </template>
            <template v-slot:item.productName="props">
                <router-link :to="props.item.link" class="text--main-yellow">
                    {{ props.item.productName }}
                </router-link>
            </template>
            <template v-slot:item.price="props">
                <v-edit-dialog
                        :return-value.sync="props.item.price"
                        large
                        persistent
                        :cancel-text="$t('cancel')"
                        :save-text="$t('change')"
                        color="orange lighten-2"
                        transition="slide-y-transition"
                        @save="updateParam({param: 'price', value: props.item.price, product: props.item})"
                >
                    <div class="text-decorated-underline">{{ props.item.price }}</div>
                    <template v-slot:input>
                        <v-text-field
                                v-model="props.item.price"
                                :label="$t('price')"
                                counter
                                autofocus
                        ></v-text-field>
                    </template>
                </v-edit-dialog>
            </template>
            <template v-slot:item.currency="props">
                <v-edit-dialog
                        :return-value.sync="props.item.currency"
                        large
                        persistent
                        :cancel-text="$t('cancel')"
                        :save-text="$t('change')"
                        color="orange lighten-2"
                        transition="slide-y-transition"
                        @save="updateCurrency({param: 'currency', price: props.item.price, value: props.item.currency, product: props.item})"
                >
                    <div class="text-decorated-underline">{{ props.item.currency }}</div>
                    <template v-slot:input>
                        <v-select
                                v-model="props.item.currency"
                                :label="$t('currency')"
                                :items="currencies"
                        ></v-select>
                    </template>
                </v-edit-dialog>
            </template>
            <template v-slot:item.withNds="{ item: { id, withNds } }">
                <v-switch
                    color="orange"
                    v-model="withNds"
                    @change="updateNds({param: 'nds', productId: id, value: $event})"
                ></v-switch>
            </template>
            <template v-slot:item.action="{ item }">
                <div style="width: 50px;">
                    <router-link :to="productEditLink(item.id)" class="mr-2">
                        <v-icon small> edit </v-icon>
                    </router-link>
                    <v-icon small @click="showDeleteSnack(item.id)">
                        delete
                    </v-icon>
                </div>
            </template>
        </v-data-table>
        <v-snackbar
                color="main--black"
                dark
                v-model="snackOpen"
                top
                v-if="snackDelete"
        >
            <span class="caption pr-4">{{ snackText }}</span>
            <span v-if="snackDelete" class="caption pr-4">{{ $t('delete') }} ?</span>
            <div>
                <v-btn text class="text--main-yellow"  @click="remove">{{ $t('yes') }}</v-btn>
                <v-btn text icon @click="closeSnack">
                    <v-icon color="grey">close</v-icon>
                </v-btn>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
    import AppSnack from '../../../../general/mixins/AppSnack';
    import ControlExistence from './ControlExistence';
    import Pack from './Pack';
    import ProfileProductsService from '../../../../app-front/services/api/ProfileProductsService';

    export default {
        name: "ProfileProducts",
        props: ['filters'],
        mixins:[AppSnack],
        components: {ControlExistence, Pack},
        data() {
            return {
                currencies:[],
                currentOrder: null,
                expandFields: {},
                headers: [],
                items: [],
                isLoading: false,
                options: {},
                page: 0,
                totalItems: null,
                updatingId: null,
                footerProps: {
                    'items-per-page-text': this.$t('rowsPerPage'),
                    'items-per-page-all-text': this.$t('all'),
                    'page-text': /*this.$t('from')*/ '',
                },
                headerProps: {
                    sortByText: this.$t('sortBy'),
                }
            }
        },
        computed: {
            itemsFilters() {
                return this.filters;
            }
        },
        methods: {
            productEditLink(id) {
                return `/profile/products/update/${id}`;
            },
            remove() {
                this.resetSnack();
                ProfileProductsService.remove(this.updatingId)
                    .then(res => {
                        this.setSuccessSnack();
                        this.setSnackText(this.$t('successfulDeleted'));
                        this.openSnack();
                        this.setItems();
                    })
                    .catch(err => {
                        console.log(err);
                        this.setDeleteSnack();
                        this.setSnackText(this.$t('dataErrorUpdated'));
                        this.openSnack();
                    });

                this.updatingId = null;
            },
            setCurrencies() {
                this.currencies = this.$store.state.currency.map(item => item.name.toUpperCase());
            },
            setItems() {
                if (this.isLoading) return false;

                this.isLoading = true;

                const params = {...this.options, filters: this.itemsFilters};
                ProfileProductsService.setLocale(this.$store.state.language.appLanguage);
                ProfileProductsService.getProducts(params)
                    .then(res => {
                        this.items = res.data.data;
                        this.totalItems = res.data.total;
                        this.isLoading = false;
                    })
                    .catch(err => {console.log(err);})
            },
            setTable() {
                ProfileProductsService.setLocale(this.$store.state.language.appLanguage);
                ProfileProductsService.getTableData()
                    .then(res => {
                        this.headers = res.data.headers;
                    })
                    .catch(err => {})
            },
            showDeleteSnack(id) {
                this.updatingId = id;
                this.resetSnack();
                this.setDeleteSnack();
                this.setDeleteSnackState();
                this.openSnack();
            },
            updateItem(data) {
                if(!data || !data.id) return false;

                const idx = this.items.findIndex(item => item.id === data.id);

                if(idx > - 1) {
                    this.items[idx] = data;
                }
            },
            updateParam(data) {
                const params = {
                    productId: data.product.id,
                    value: data.value
                };

                ProfileProductsService.updateParam(data.param, params)
                    .then(res => {
                        this.resetSnack();
                        this.setSuccessSnack();
                        this.setSnackText(this.$t('dataSuccessUpdated'));
                        this.openSnack();
                    })
                    .catch(err => {
                        this.resetSnack();
                        this.setDeleteSnack();
                        this.setSnackText(this.$t('dataErrorUpdated'));
                        this.openSnack();
                    });
            },
            updateCurrency(data) {

                const params = {
                    productId: data.product.id,
                    value: data.value,
                    price: data.price
                };

                ProfileProductsService.updateParam(data.param, params)
                    .then(res => {
                        this.resetSnack();
                        this.setSuccessSnack();
                        this.setSnackText(this.$t('dataSuccessUpdated'));
                        this.openSnack();
                    })
                    .catch(err => {
                        this.resetSnack();
                        this.setDeleteSnack();
                        this.setSnackText(this.$t('dataErrorUpdated'));
                        this.openSnack();
                    });
            },
            updateNds({param, ...data}) {
                ProfileProductsService.updateParam(param, data)
                    .then(res => {
                        this.resetSnack();
                        this.setSuccessSnack();
                        this.setSnackText(this.$t('dataSuccessUpdated'));
                        this.openSnack();
                    })
                    .catch(err => {
                        this.resetSnack();
                        this.setDeleteSnack();
                        this.setSnackText(this.$t('dataErrorUpdated'));
                        this.openSnack();
                    });
            },
        },
        created() {
            this.setCurrencies();
            this.setTable();
        },
        watch: {
            itemsFilters: {
                handler() {
                    this.setItems();
                },
                deep: true
            },
            options: {
                handler() {
                    this.setItems();
                },

                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
